import moment from "moment-timezone";

import { convertAndAddToObject } from "./convertAndAddToObject";

export function convertToDurationAndAddToObject<T, U extends number>(
	obj: T,
	value: U,
	key: keyof T
) {
	return convertAndAddToObject(obj, value, key, value =>
		moment.duration({ hours: value })
	);
}
